<div id="send-push-notification-dialog">
  <div id="send-push-notification-title">
    Push értesítés küldése
  </div>
  <form [formGroup]="notificationFG">
    <div id="send-push-notification-inputs">
      <!-- Identifier type selector -->
      <div class="input-row">
        <mat-form-field appearance="outline" style="width: 150px; margin-right: 10px;">
          <mat-label>Azonosító típusa</mat-label>
          <mat-select [formControl]="identifierTypeFC">
            <mat-option *ngFor="let type of identifierTypes" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>{{ getIdentifierLabel() }}</mat-label>
          <input matInput [formControl]="identifierValueFC" [placeholder]="getIdentifierPlaceholder()" required />
          <mat-error *ngIf="identifierValueFC.hasError('required')">Kötelező mező!</mat-error>
        </mat-form-field>
      </div>

      <!-- Notification title -->
      <div class="input-row">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Értesítés címe</mat-label>
          <input matInput [formControl]="titleFC" placeholder="pl. Fontos értesítés" required />
          <mat-hint>Ez jelenik meg az értesítés címeként.</mat-hint>
          <mat-error *ngIf="titleFC.hasError('required')">Kötelező mező!</mat-error>
        </mat-form-field>
      </div>

      <!-- Notification body -->
      <div class="input-row">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Értesítés tartalma</mat-label>
          <textarea matInput [formControl]="bodyFC" rows="4" placeholder="pl. Kérjük, ellenőrizze a postafiókját..." required></textarea>
          <mat-hint>Ez jelenik meg az értesítés szövegeként.</mat-hint>
          <mat-error *ngIf="bodyFC.hasError('required')">Kötelező mező!</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-raised-button mat-dialog-close [disabled]="isSending">
        Bezár
      </button>
      <button mat-raised-button color="primary" [disabled]="notificationFG.invalid || isSending" (click)="handleSendButtonClick()">
        <span *ngIf="!isSending">Küldés</span>
        <span *ngIf="isSending">Küldés...</span>
      </button>
    </div>
  </form>
</div>
